import { type FC, type PropsWithChildren } from 'react';

import kangaroosSvg from './assets/Kangaroos.svg';
import { StyledImg } from './styled';

export const KangaroosImage: FC<PropsWithChildren> = () => {
  return <StyledImg src={kangaroosSvg} alt="Two Kangaroos" />;
};
